module.exports = __webpack_public_path__ + "media/rating/not_really-984cbbe2.svg";